var render, staticRenderFns
import script from "./vu-title.vue?vue&type=script&lang=jsx&"
export * from "./vu-title.vue?vue&type=script&lang=jsx&"
import style0 from "./vu-title.vue?vue&type=style&index=0&id=2feac9c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feac9c6",
  null
  
)

export default component.exports